import React from 'react';

import './index.scss';

export default function Actions({
    disabled,
    onPreferencesFormSubmit,
    onCancelClick,
    isSaving,
    actionIndex
  }) {
    return(
        <div className="preferences__content__action">
        <button
          type="submit"
          className="btn btn--primary btn--lg"
          disabled={disabled}
          onClick={(e) => {
            e.preventDefault();
            onPreferencesFormSubmit(actionIndex);
          }}
        >
          {isSaving ? 'Saving...' : 'Save'}
        </button>
        <button
          className="btn btn--link button-cancel"
          onClick={(e) => {
            e.preventDefault();
            onCancelClick();
          }}
        >
          Cancel
        </button>
      </div>
    )

  }

//   <div className="preferences__content__action">
//   <button
//     type="button"
//     className="btn btn--primary btn--lg"
//     disabled={
//       this.state.isSaving ||
//       !isMandatoryComplete(this.state.preferences)
//     }
//     onClick={this.onPreferencesFormSubmit}
//   >
//     {this.state.isSaving ? 'Saving...' : 'Save'}
//   </button>
// </div>